/* eslint-disable camelcase */
import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import ToastComponent from '../../components/toast';
import { SupportContactService } from '../../services/wealthlane-customer-services/services/SupportContactService';
import { Wealthlane_CustomerService_Dtos_SupportContact_SaveSupportContactsRequestDto } from '../../services/wealthlane-customer-services/models/Wealthlane_CustomerService_Dtos_SupportContact_SaveSupportContactsRequestDto';
import { Wealthlane_CustomerService_Dtos_Response_ResponseDto } from '../../services/wealthlane-customer-services';

const usePostSupportContacts = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<
  Wealthlane_CustomerService_Dtos_Response_ResponseDto | undefined,
  unknown,
  Wealthlane_CustomerService_Dtos_SupportContact_SaveSupportContactsRequestDto,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (
      payload: Wealthlane_CustomerService_Dtos_SupportContact_SaveSupportContactsRequestDto
    ) => {
      return await handleRequest(
        SupportContactService.postApiCustomerApiAppSupportContactSaveSupportContacts(payload)
      );
    },
    {
      onSuccess: async (
        response: Wealthlane_CustomerService_Dtos_Response_ResponseDto | undefined
      ) => {
        if (response != null) {
          await queryClient.invalidateQueries('getSupportContacts');
          await queryClient.invalidateQueries('getSupportContactByCompanyId');
          closeModal();
          toast.success(
            <ToastComponent label='Success' message='Support Emails contacts updated!' />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostSupportContacts;
